/* eslint-disable no-undef */
import { message, notification } from 'antd'
import { all, call, put, takeEvery } from 'redux-saga/effects'

import { actions } from 'src/redux/facebook-pixel/actions'
import { serviceFacebookPixel } from 'src/services/api/facebookPixel'

function load (payload) {
  return setState({ loading: payload })
}

function setState (payload) {
  return put({
    type: 'facebook_pixel/set_state',
    payload
  })
}

export function * getFacebookPixel ({ payload }) {
  yield load(true)
  const { token } = payload

  const response = yield call(serviceFacebookPixel.get, token)
  if (response.status === 200) {
    yield setState({
      dataPixels: response.data.data,
      meta: response.data.data.meta,
      loading: false
    })
  } yield load(false)
}

export function * getFacebookPixelQR ({ payload }) {
  yield load(true)
  const { qrcodeId } = payload

  const response = yield call(serviceFacebookPixel.getQR, qrcodeId)
  if (response.status === 200) {
    yield setState({
      dataPixels: response.data.data,
      meta: response.data.data.meta,
      loading: false
    })
  } yield load(false)
}

export function * createFacebookPixel ({ payload }) {
  yield load(true)
  const { token, data } = payload

  const response = yield call(serviceFacebookPixel.create, token, data)
  if (response.status === 202) {
    yield setState({
      loading: false,
      dataPixels: response.data.data,
      popupSuccess: true
    })
    message.success('Created success')
  } else {
    yield load(false)
    message.error('created failed! check your field')
  }
}

export function * deleteFacebookPixel ({ payload }) {
  yield load(true)
  const { token } = payload

  const response = yield call(serviceFacebookPixel.delete, token)
  if (response.status === 202) {
    yield put({
      type: 'facebook_pixel/get_facebook_pixel',
      payload: { token }
    })
    notification.warning({
      message: 'Delete Product Success!',
      description: 'Product delete for permanent '
    })
  } yield load(false)
}

export default function * rootSaga () {
  yield all([
    takeEvery(actions.get_facebook_pixel, getFacebookPixel),
    takeEvery(actions.get_facebook_pixel_qr, getFacebookPixelQR),
    takeEvery(actions.delete_facebook_pixel, deleteFacebookPixel),
    takeEvery(actions.create_facebook_pixel, createFacebookPixel)
  ])
}
